import Box from "@mui/material/Box";
import { useAuth } from "@bw/shared/hooks";
import { useLocation } from "react-router-dom";
import { HomeContextRail } from "../../modules/home";
import { PLAYER_APP_BAR_HEIGHT } from "./AppBar";

export function ContextRail() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  if (pathname !== "/" || loading || !user) return null;

  return (
    <Box
      component="aside"
      aria-label="Context"
      sx={{
        minWidth: 0,
        position: { xs: "static", lg: "sticky" },
        top: `calc(${PLAYER_APP_BAR_HEIGHT} + 1.5rem)`,
      }}
    >
      <HomeContextRail />
    </Box>
  );
}
